import { FC } from "react";
import KickImage from 'Reuseables/KickImage';
import styled from "styled-components";

//Constants
import { FontFamilyBold, FontFamilyRegular } from "../../constants"

// Define Interface
type Props = {
  className?: string;
}

interface StyledCompProps {
  fontFamilyBold?: string;
  fontFamilyRegular?: string;
}

const StyledComponent = styled.div<StyledCompProps>`
  border: 4px solid #c2e6d7;
  border-radius: 50%;
  border-top: 4px solid #009958;
  width: 50px;
  height: 50px;
  -webkit-animation: spin 1s linear infinite; /* Safari */
  animation: spin 1s linear infinite;

  /* Safari */
  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`
StyledComponent.defaultProps = {
  fontFamilyBold: FontFamilyBold,
  fontFamilyRegular: FontFamilyRegular
}


const LoadingIcon: FC<Props> = ({
  className
}) => {
  return (
    <StyledComponent className={className} />
  )
}
LoadingIcon.defaultProps = {
  className: ""
}

export default LoadingIcon